module.exports = __webpack_public_path__ + "img/bg4-flipped.72a61bbf.jpg";